'use strict';

require('ngmap');

var mapModuleName = 'jdro-g-map';
angular.module(mapModuleName, ['ngDro', 'ngMap']);

global.ngDroModules.push(mapModuleName);

//var gMapmodule = angular.module('jdro-g-map', ['ngDro', 'ngMap']);
//global.ngDroModules.push(gMapmodule.name);

//******************************* CONTROLLERS ***********************************
angular.module(mapModuleName).controller('gMapIndexCtrl', require('./components/index/indexCtrl'));

//******************************* DIRECTIVES ***********************************
angular.module(mapModuleName).directive('mapDirective', require('./components/mapDirective/mapDirective'));

//******************************* SERVICES ***********************************
angular.module(mapModuleName).service('staticMapService', require('./services/staticMapService'));

//******************************* CONFIG ***********************************
angular.module(mapModuleName).config(require('./module-states'));
angular.module(mapModuleName).config(require('./module-translations'));

angular.module(mapModuleName).run(function ($rootScope, MainViews) {

//    //leggo la configurazione esterna del modulo
//    if (!$rootScope.configs)
//        $rootScope.configs={};
//    $rootScope.configs.ngDroAstralSituationRecordMainConfig=ngDroAstralSituationRecordMainConfig;

    /** Registo il modulo per il menù **/

    MainViews.register({
        title: 'gMap',
        state: 'g-map-index',
        order: 100,
        iconClass: 'fa fa-fw fa-map',
        children: []
    });

});




// WEBPACK FOOTER //
// ./src/modules/ngDro-gMapModule/module.js